<template>
  <div class="router-header flex flex-wrap items-center">
    <div>
      <vs-popup
        fullscreen
        :title="$t('labels.participants_list')"
        :active.sync="isParticipants"
      >
        <div class="user-table">
          <vs-table pagination max-items="15" :data="orders">
            <template slot="thead">
              <vs-th>{{ $t("labels.name") }}</vs-th>
              <vs-th
                >{{ $t("labels.net_amount") }} {{ $t("labels.dlr") }}</vs-th
              >
              <vs-th
                >{{ $t("labels.hobi_charge") }} {{ $t("labels.dlr") }}</vs-th
              >
              <vs-th
                >{{ $t("labels.service_charge") }} {{ $t("labels.dlr") }}</vs-th
              >
              <vs-th>{{ $t("labels.Payment_status") }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr
                :data="tr"
                :key="indextr"
                v-for="(tr, indextr) in data"
                style="cursor: auto !important"
              >
                <vs-td class="word-break" style="width: 35% !important">
                  <p v-if="tr.user_detail">
                    <span>{{ tr.user_detail.name | capitalize }}</span>
                  </p>
                </vs-td>
                <vs-td>
                  <span>{{ tr.class_price }}</span>
                  <span v-if="!tr.class_price">---</span>
                </vs-td>
                <vs-td>
                  <span>{{
                    (tr.hobi_charge * tr.class_price).toFixed(2)
                  }}</span>
                  <span v-if="!tr.hobi_charge">---</span>
                </vs-td>
                <vs-td>
                  <span>{{ tr.total_amount - tr.class_price }}</span>
                  <span v-if="!tr.total_amount">---</span>
                </vs-td>
                <vs-td>
                  <span v-if="tr.payment_status == 'F'" class="rejected">{{
                    $t("labels.pending")
                  }}</span>
                  <span v-if="tr.payment_status == 'A'" class="approved">{{
                    $t("labels.success")
                  }}</span>
                  <p>{{ tr.payment_status | capitalize }}</p>
                  <span v-if="!tr.payment_status">---</span>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-popup>
    </div>
    <div class="content-area__heading">
      <p class="font">{{ $t("labels.bookings") }}</p>
    </div>
    <div class="ml-auto md:block">
      <vs-button
        color="success"
        icon="icon-search"
        @click="data_hide = !data_hide"
        icon-pack="feather"
        >Search</vs-button
      >
    </div>
    <vx-card class="mt-4" v-show="data_hide">
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/4 w-full">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            placeholder="Hosted By"
            icon-no-border
            label="Hosted by"
            v-model="hosted_by"
            @keyup.delete="getAllTeacher()"
          />
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <label class="vs-input--label">{{ $t("labels.mode") }}</label>
          <v-select
            v-validate="'required'"
            :placeholder="$t('labels.select_mode')"
            name="mode"
            v-model="mode"
            :success="true"
            :clearable="false"
            success-text="This field is valid"
            :options="ModeArray"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            class="w-full"
            label="value"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button color="success" class="mr-3 mb-2" @click="getAllTeacher()"
            >Search</vs-button
          >
          <vs-button color="danger" class="mb-2 mr-3" @click="resetForm()"
            >Reset</vs-button
          >
          <vs-button color="black" class="mb-2" @click="data_hide = !data_hide"
            >Close</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card class="mt-4">
      <vs-table :max-items="perPage" stripe :data="users">
        <template slot="thead">
          <vs-th>{{ $t("labels.class_title") }}</vs-th>
          <vs-th>{{ $t("labels.hosted_by") }}</vs-th>
          <vs-th>{{ $t("labels.mode") }}</vs-th>
          <vs-th>{{ $t("labels.city") }}</vs-th>
          <vs-th>{{ $t("labels.price") }}</vs-th>
          <vs-th>{{ $t("labels.total_bookings") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].title">
              <router-link
                :to="{ name: 'ClassById', params: { id: data[indextr].id } }"
              >
                {{ data[indextr].title }}
              </router-link>
            </vs-td>

            <vs-td class="word-break" :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td>

            <vs-td :data="data[indextr].type">
              <p v-if="data[indextr].type == 'OF'">
                {{ $t("labels.offline") }}
              </p>
              <p v-if="data[indextr].type == 'ON'">{{ $t("labels.online") }}</p>
            </vs-td>

            <vs-td :data="data[indextr].location">
              {{ data[indextr].location | address_format }}
            </vs-td>

            <vs-td :data="data[indextr].fees">
              {{ data[indextr].fees }}
            </vs-td>

            <!-- <vs-td :data="data[indextr].total_booked">
                {{ data[indextr].total_booked }}
                </vs-td> -->
            <vs-td>
              <span
                class="cursor-pointer"
                v-if="data[indextr].booker_details.length != 0"
                @click.stop="OpenParticipants(data[indextr].booker_details)"
              >
                <vs-chip color="success">
                  {{ data[indextr].booker_details.length }}</vs-chip
                >
              </span>
              <span
                class="cursor-pointer"
                v-if="!data[indextr].booker_details.length != 0"
              >
                <vs-chip color="success">
                  {{ data[indextr].booker_details.length }}</vs-chip
                >
              </span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <div class="float-right mt-5">
      <vs-pagination
        ref="paginationApplication"
        :total="totalPage"
        v-model="currentPage"
      ></vs-pagination>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
export default {
  components: {
    "v-select": vSelect,
  },
  data: () => ({
    value: "",
    select2: "",
    data_hide: false,
    users: [],
    hosted_by: "",
    mode: "",
    classes: "",
    changeID: null,
    deleteID: null,
    page: 1,
    perPage: 10,
    totalPage: 0,
    currentPage: 1,
    isParticipants: false,
    ModeArray: [
      {
        id: "ON",
        value: "Online",
      },
      {
        id: "OF",
        value: "Offline",
      },
    ],
  }),
  watch: {
    currentPage(nv) {
      if (nv) {
        // this.$route.query.page = nv;
        this.getAllTeacher();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getAllTeacher();
      }
    },
    search(nv) {
      if (!nv) {
        this.perPage = 10;
        this.currentPage = 1;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
        this.getAllTeacher();
      }
    },
  },
  methods: {
    getAllTeacher() {
      let input = {
        hosted_by: this.hosted_by,
        mode: this.mode,
        page: this.currentPage,
        perPage: this.perPage,
      };
      axios
        .post("class/allBookingsForAdmin", input)
        .then((response) => {
          let data = response.data.data;
          this.users = data.class_details;
          console.log(this.users);
          if (data.count < this.perPage) {
            this.currentPage = 1;
          }
          this.totalPage = Math.ceil(data.count / this.perPage);
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    resetForm() {
      (this.hosted_by = ""), (this.mode = "");
      this.getAllTeacher();
    },
    ClassDetails(id) {
      this.$router.push({ name: "ClassById", params: { id: id } });
    },
    OpenParticipants(orders) {
      this.orders = orders;
      this.isParticipants = true;
      //this.$validator.reset();
    },
  },
  mounted() {
    this.getAllTeacher();
  },
};
</script>

<style lang="scss" scoped>
</style>